/**
 * Dependencies.
 */
import de from './de.translate';
import el from './el.translate';
import en from './en.translate';
import es from './es.translate';
import fi from './fi.translate';
import fr from './fr.translate';
import it from './it.translate';
import pl from './pl.translate';
import pt from './pt.translate';

/**
 * Export.
 */
export default {
  'de-DE': { EXTERNAL_APPLICATIONS: de },
  'el-GR': { EXTERNAL_APPLICATIONS: el },
  'en-US': { EXTERNAL_APPLICATIONS: en },
  'es-ES': { EXTERNAL_APPLICATIONS: es },
  'fi-FI': { EXTERNAL_APPLICATIONS: fi },
  'fr-FR': { EXTERNAL_APPLICATIONS: fr },
  'it-IT': { EXTERNAL_APPLICATIONS: it },
  'pl-PL': { EXTERNAL_APPLICATIONS: pl },
  'pt-PT': { EXTERNAL_APPLICATIONS: pt }
};
